import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../..';

interface SelectedNode {
  catalogId: string;
  path: string[];
}

interface PrestateState {
  selectedNode?: SelectedNode;
  sourceTreeState?: string[];
  targetTreeState?: string[];
}

const initialState: PrestateState = {};

const prestateSlice = createSlice({
  name: 'prestate',
  initialState,
  reducers: {
    depopulate(state, action: PayloadAction<{ properties?: string[] }>) {
      const { properties = [] } = action.payload;
      if (properties.length === 0) return;

      properties.forEach((prop) => {
        delete state[prop as keyof PrestateState];
      });
    },
    populate(
      state,
      action: PayloadAction<{
        selectedNode?: SelectedNode;
        sourceTreeState?: string[];
        targetTreeState?: string[];
      }>,
    ) {
      const { selectedNode, sourceTreeState, targetTreeState } =
        action.payload || {};
      if (
        sourceTreeState ||
        targetTreeState ||
        (selectedNode?.catalogId && selectedNode?.path)
      ) {
        state.selectedNode = selectedNode;
        state.sourceTreeState = sourceTreeState;
        state.targetTreeState = targetTreeState;
      } else {
        return initialState;
      }
    },
  },
});

export const { depopulate, populate } = prestateSlice.actions;
export default prestateSlice.reducer;

export const selectPrestate = (state: RootState): PrestateState => state.prestate;
